// extracted by mini-css-extract-plugin
module.exports = {"crumbs":"Breadcrumbs-module--crumbs--yCfVB"};